import React from 'react';
import { ArrowRightIcon, SparklesIcon } from 'lucide-react';
import { CountdownBadge } from './CountdownBadge';
export function HeroSection() {
  return <section className="bg-spiritual-radial py-12 md:py-24 relative overflow-hidden" data-id="element-36">
      {/* Subtle decorative elements */}
      <div className="absolute inset-0 opacity-5" data-id="element-37">
        <div className="absolute top-20 left-10 w-72 h-72 bg-spiritual-400 rounded-full blur-3xl" data-id="element-38" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-spiritual-600 rounded-full blur-3xl" data-id="element-39" />
      </div>

      <div className="max-w-7xl mx-auto px-5 md:px-8 relative z-10" data-id="element-40">
        <div className="flex flex-col md:flex-row items-center gap-10 md:gap-16" data-id="element-41">
          {/* Text Content */}
          <div className="md:w-1/2 space-y-6 text-center" data-id="element-42">
            <div className="flex items-center justify-center gap-2 mb-2" data-id="element-43">
              <SparklesIcon className="w-5 h-5 text-spiritual-400" aria-hidden="true" data-id="element-44" />
              <span className="text-spiritual-300/80 font-body text-sm uppercase tracking-widest" data-id="element-45">
                Sanación Transgeneracional
              </span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold leading-tight text-center" data-id="element-46">
              <span className="text-spiritual-100" data-id="element-47">
                El Código de Sanación del Árbol:
              </span>{' '}
              <span className="text-gold-gradient" data-id="element-48">
                Libera tu Abundancia Heredada
              </span>
            </h1>

            <h2 className="text-lg md:text-2xl font-heading font-normal text-spiritual-200/90 leading-relaxed italic text-center" data-id="element-49">
              Corta las lealtades invisibles de escasez que arrastras de tu
              linaje y deja de trabajar duro por un dinero que siempre se
              esfuma.
            </h2>

            <div className="bg-spiritual-800/50 border-l-4 border-spiritual-400 p-5 rounded-r-lg" data-id="element-50">
              <p className="text-base md:text-lg text-spiritual-200 font-body leading-relaxed" data-id="element-51">
                Son las 11 de la noche. Estás frente a la calculadora, sintiendo
                ese nudo en la garganta porque, a pesar de tus esfuerzos y
                sacrificios, los números simplemente no cuadran. No es que no
                sepas trabajar, es que sientes que hay un{' '}
                <em className="text-spiritual-300 font-bold not-italic" data-id="element-52">
                  "techo de cristal" invisible
                </em>{' '}
                que te impide prosperar, por más que lo intentes.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4" data-id="element-53">
              <a href="#comprar" className="inline-flex items-center justify-center text-center gap-2 bg-gradient-to-r from-spiritual-400 to-spiritual-500 hover:from-spiritual-500 hover:to-spiritual-400 text-spiritual-900 font-body font-bold px-8 py-4 rounded-xl text-base md:text-lg transition-all duration-300 shadow-xl shadow-spiritual-400/20 transform hover:scale-105 active:scale-95 pulse-glow" data-id="element-54">
                Quiero Sanar Mi Linaje Ahora
                <ArrowRightIcon className="w-5 h-5" aria-hidden="true" data-id="element-55" />
              </a>
              <CountdownBadge data-id="element-56" />
            </div>
          </div>

          {/* Product Image */}
          <div className="md:w-1/2 flex justify-center" data-id="element-57">
            <div className="relative animate-float" data-id="element-58">
              <div className="absolute -inset-4 bg-gradient-to-br from-spiritual-400/20 to-spiritual-600/10 rounded-3xl blur-2xl" data-id="element-59" />
              <img src="https://cdn.magicpatterns.com/uploads/pUSaaYEsHUnEUsPi228GQh/Portada_ebook_ipad.png" alt="Código de Sanación del Árbol - eBook en iPad mostrando un árbol dorado con raíces de ADN" className="relative w-full max-w-md md:max-w-lg rounded-2xl shadow-2xl shadow-spiritual-900/50" data-id="element-60" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}